import { render } from "./Concept_index_en.vue?vue&type=template&id=d8141230&scoped=true"
import script from "./Concept_index_en.vue?vue&type=script&lang=js"
export * from "./Concept_index_en.vue?vue&type=script&lang=js"

import "./Concept_index_en.vue?vue&type=style&index=0&id=d8141230&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d8141230"

export default script